module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/logo-world-class-dads-25405f6a29dd791fced86df0a7dd6a3a.svg";